import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Label,
  Row,
  Col,
  Input,
  CustomInput,
  DropdownItem,
  Button,
  ButtonGroup,
} from 'reactstrap'
import DatePicker from 'react-datepicker'
import shortid from 'shortid'
import set from 'lodash/set'
import get from 'lodash/get'
import find from 'lodash/find'
import moment from '../../../lib/moment.js'
import styled from 'styled-components'
import SearchIcon from "../../../static/images/search_icon.svg"
import * as timesheetHelper from '../helpers/timesheet'

class FillHoursForm extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if ((prevState.selectedStartDate === undefined || prevState.selectedEndDate === undefined)
    || (get(nextProps, 'selectedDate') !== prevState.selectedDate)) {
      set(tempState, 'selectedStartDate', moment(get(nextProps, 'selectedDate')).startOf('month'))
      set(tempState, 'selectedEndDate', moment(get(nextProps, 'selectedDate')).endOf('month'))
      set(tempState, 'selectedDate', get(nextProps, 'selectedDate'))
    }
    if (prevState.sumHoursByDate === undefined ||
      (get(nextProps, 'sumHoursByDate')) !== prevState.sumHoursByDate) {
      set(tempState, 'sumHoursByDate', get(nextProps, 'sumHoursByDate'))
    }
    if (prevState.myTimesheet === undefined || (get(nextProps, 'myTimesheet') !== prevState.myTimesheet)) {
      set(tempState, 'myTimesheet', get(nextProps, 'myTimesheet'))
    }
    return tempState
  }

  state={
    selectedType: 1,
    specificHours: 0,
    remainHours: true,
    checkedTask: '',
    searchFillHours: '',
  }

  handleInputFillHours = (field, data) => {
    switch (field) {
      case 'startDate': {
        this.setState({ selectedStartDate: data })
        break
      }
      case 'endDate': {
        this.setState({ selectedEndDate: data })
        break
      }
      case 'type': {
        this.setState({ selectedType: data })
        break
      }
      case 'search': {
        this.setState({ searchFillHours: this.state.tempSearch })
        break
      }
      case 'specificHours': {
        this.setState({ specificHours: data.target.value })
        break
      }
      case 'remainHours': {
        this.setState({ remainHours: !this.state.remainHours })
        break
      }
      case 'task': {
        this.setState({ checkedTask: data })
        break
      }
      default:
        break
    }
  }

  handleClickButton = (type) => {
    this.setState({
      selectedType: 1,
      specificHours: 0,
      remainHours: true,
      checkedTask: '',
      searchFillHours: '',
      selectedStartDate: moment(this.state.selectedDate).startOf('month'),
      selectedEndDate: moment(this.state.selectedDate).endOf('month'),
    })
    const isSubcontract = get(this.props, 'authData.user.employee_type') === 'Subcontract'
    switch (type) {
      case 'apply': {
        const {
          myTimesheet,
          selectedStartDate,
          selectedEndDate,
          remainHours,
          specificHours,
          checkedTask,
          sumHoursByDate,
        } = this.state
        const newProjects = timesheetHelper.fillHoursTimesheet(
          sumHoursByDate, checkedTask, myTimesheet, selectedStartDate, selectedEndDate,
          remainHours, specificHours, isSubcontract)
        this.props.applyFillHours(newProjects)
        break
      }
      case 'cancel': {
        this.props.toggle()
        break
      }
      default:
        break
    }
  }

  render() {
    const { open } = this.props
    const {
      selectedType,
      searchFillHours,
      selectedStartDate,
      selectedEndDate,
      specificHours,
      remainHours,
      checkedTask,
      myTimesheet,
    } = this.state
    const myProjects = get(myTimesheet, 'timesheet.projects', [])
    const projects = timesheetHelper.filterProjectsFillHours(
      myProjects, get(myTimesheet, 'projects', []), selectedType, searchFillHours)

    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        size='lg'
        isOpen={ open }
        toggle={ () => this.handleClickButton('cancel') }
      >
        <ModalHeader toggle={ () => this.handleClickButton('cancel') }>
          <HeadLabel>Fill Hours</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Container>
            <Row>
              <Col sm={ 6 } style={ { borderRight: '1px solid #E5E5E5' } }>
                <TypeButtonGroup>
                  <TypeButton
                    color="primary"
                    style={ {
                      backgroundColor: (selectedType === 1) ? '#AD2624' : '#FFFFFF',
                      color: (selectedType === 1) ? '#FFFFFF' : '#D44B49',
                      border: '1px solid #AD2624',
                    } }
                    onClick={ () => this.handleInputFillHours('type', 1) }
                    active={ selectedType === 1 }
                  >All
                  </TypeButton>
                  <TypeButton
                    color="primary"
                    style={ {
                      backgroundColor: (selectedType === 2) ? '#AD2624' : '#FFFFFF',
                      color: (selectedType === 2) ? '#FFFFFF' : '#D44B49',
                      border: '1px solid #AD2624',
                    } }
                    onClick={ () => this.handleInputFillHours('type', 2) }
                    active={ selectedType === 2 }
                  >Chargeable
                  </TypeButton>
                  <TypeButton
                    color="primary"
                    style={ {
                      backgroundColor: (selectedType === 3) ? '#AD2624' : '#FFFFFF',
                      color: (selectedType === 3) ? '#FFFFFF' : '#D44B49',
                      border: '1px solid #AD2624',
                    } }
                    onClick={ () => this.handleInputFillHours('type', 3) }
                    active={ selectedType === 3 }
                  >Non-Charge
                  </TypeButton>
                </TypeButtonGroup>
                <SearchField
                  placeholder='Search for project'
                  onChange={ (e) => {
                    this.setState({ tempSearch: e.target.value })
                    if (e.target.value === '') this.setState({ searchFillHours: '' })
                  }
                  }
                  onKeyDown={ (e) => {
                    if (e.keyCode === 13) this.handleInputFillHours('search', e)
                  }
                  }
                />
                <DropdownItem divider />
                <List>
                  {
                    projects.map((project) => {
                      const proj = find(get(myTimesheet, 'projects', []),
                        { _id: project.project_id }) || {}
                      return (
                        <div key={ shortid() }>
                          <Label>{ `${get(proj, 'project_code', '')} - ${get(proj, 'name', '')}` }</Label>
                          {
                            get(project, 'tasks', []).map((task, taskID) => {
                              return (
                                <div key={ shortid() } style={ { marginLeft: 20 } }>
                                  <CustomInput
                                    id={ `${get(project, 'project_id')}^${get(project, 'approver_id')}^${get(project, 'key')}^${taskID}^${get(task, 'task_name')}` }
                                    name='task'
                                    type='radio'
                                    label={ task.task_name === '' ? '-' : task.task_name }
                                    onChange={ () =>
                                      this.handleInputFillHours('task', `${get(project, 'project_id')}^${get(project, 'approver_id')}^${get(project, 'key')}^${taskID}^${get(task, 'task_name')}`)
                                    }
                                    checked={ checkedTask.includes(`${get(project, 'project_id')}^${get(project, 'approver_id')}^${get(project, 'key')}^${taskID}^${get(task, 'task_name')}`) }
                                  />
                                </div>
                              )
                            })
                          }
                          <br />
                        </div>
                      )
                    })
                  }
                </List>
              </Col>
              <Col sm={ 6 }>
                <Row>
                  <Col>
                    <LabelDetail >Start Date</LabelDetail>
                    <CustomDatePicker
                      onChange={ (e) => this.handleInputFillHours('startDate', e) }
                      placeholderText='DD/MM/YYYY'
                      selected={ selectedStartDate }
                      dateFormat="DD/MM/YYYY"
                      showYearDropdown
                      showMonthDropdown
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <LabelDetail >End Date</LabelDetail>
                    <CustomDatePicker
                      onChange={ (e) => this.handleInputFillHours('endDate', e) }
                      placeholderText='DD/MM/YYYY'
                      selected={ selectedEndDate }
                      dateFormat="DD/MM/YYYY"
                      showYearDropdown
                      showMonthDropdown
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <CustomRadioInput
                      type="radio"
                      id="remaining_hours"
                      name="customRadio"
                      label="Remaining Hours"
                      checked={ remainHours }
                      onChange={ () => this.handleInputFillHours('remainHours') }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <CustomRadioInput
                      type="radio"
                      id="specific_hours"
                      name="customRadio"
                      label="Specific Hours"
                      checked={ !remainHours }
                      onChange={ () => this.handleInputFillHours('remainHours') }
                    />
                    <InputField
                      id='auto_fill_specific_hours'
                      type='number'
                      step={ 0.5 }
                      max={ 8 }
                      min={ 0 }
                      disabled={ remainHours }
                      value={ specificHours }
                      onFocus={ () => document.getElementById('auto_fill_specific_hours').select() }
                      onChange={ (e) => {
                        if (e.target.value < 0) e.target.value = 0
                        else if (e.target.value > 8) e.target.value = 8
                        this.handleInputFillHours('specificHours', e)
                      }
                      }
                    />
                    <Message>
                      *Maximum 8 hours per day.
                    </Message>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <FooterButton
            background='#5CB85C'
            color='white'
            disabled={ checkedTask === '' }
            onClick={ () => this.handleClickButton('apply') }
          >
          Apply
          </FooterButton>
          <FooterButton
            background='white'
            color='black'
            onClick={ () => this.handleClickButton('cancel') }
          >
          Cancel
          </FooterButton>
        </ModalFooter>
      </Modal>
    )
  }
}

FillHoursForm.propTypes = {
  toggle: PropTypes.func,
  applyFillHours: PropTypes.func,
  open: PropTypes.bool,
}
FillHoursForm.defaultProps = {
  toggle: () => {},
  applyFillHours: () => {},
  open: false,
}

export default FillHoursForm

const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  color: #AD2624;
`
const List = styled.div`
  height: calc(100vh - 500px);
  @media (max-width: 1024px) {
    height: calc(100vh - 400px);
  }
  overflow:scroll;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  ::-webkit-scrollbar:vertical {
    width: 11px;
  }
  ::-webkit-scrollbar:horizontal {
    height: 11px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
  }
`
const LabelDetail = styled(Label)`
  width: 100%;
  font-family: 'Gotham' !important;
  font-size: 12px;
`
const InputField = styled(Input)`
  font-family: 'Gotham' !important;
  width : 50% ;
  font-size: 12px ;
`
const SearchField = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 10px;
  box-sizing: border-box;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  padding-left: 30px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`
const CustomRadioInput = styled(CustomInput)`
  font-family: 'Gotham-Bold' !important;
  margin-top: 10px;
`
const CustomDatePicker = styled(DatePicker)`
    font-family: 'Gotham' !important;
    width : 216px ;
    height : 30px ;
    font-size: 12px ;
    padding-left: 5%;
    float: right;
    border-radius: 5px;
    border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
  @media (max-width: 575.98px) {
      width: 100%;
    }
`
const TypeButtonGroup = styled(ButtonGroup)`
  display: flex;
  font-family: 'Gotham' !important;
`
const TypeButton = styled(Button)`
  width: 100%;
`
const Message = styled.p`
  font-family: 'Gotham-Light' !important;
  font-size: 12px ;
`
const FooterButton = styled(Button)`
  margin-right: 10px;
  background-color: ${props => props.background};
  color: ${props => props.color};
  font-family: 'Gotham-Bold' !important;
  border: 1px solid #CCCCCC;
`




// WEBPACK FOOTER //
// ./src/components/timesheet/form/fill-hours.js